module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1040_-9bd20ebfee9f64c43ec0776af276580b.png";